import { useFormik, Form, FormikProvider } from 'formik';
import { Button } from 'styled';
import InputField from 'components/formik/InputField';
import Model from 'components/Modal';
import { getAllData, updateDocumentByID } from 'apis/customApiHandler';
import { useQuery, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { useState } from 'react';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import { saveErrorCreationEvent } from 'utils/analytics';
import { ANALYTICS_EVENTS } from 'utils/analyticsEvents';

const EditPermissions = ({ handleClick, role, desable, permissions }) => {
  const [isDesable, setIsDesable] = useState(desable);
  const queryClient = useQueryClient();
  const location = useLocation();

  function roleEditEventFunc(eventName, modelName, params) {
    return saveErrorCreationEvent(eventName, modelName, "Roles & Permissions", location.pathname, params);
  }

  const formik = useFormik({
    initialValues: {
      name: role?.name,
      permissions: role?.permissions.map((permission) => permission?._id) || [],
    },
    onSubmit: async (values) => {
      const eventParams = {
        edited_role_id: role?._id,
        role_name: values.name,
        permissions: permissions?.filter((p) => values.permissions.includes(p._id))?.map((p) => p.name),
      };
      try {
        roleEditEventFunc(ANALYTICS_EVENTS.CLICK_EDIT_CHANGES, "Edit Role", eventParams);
        const Data = await updateDocumentByID('roles', role?._id, values);
        if (Data) {
          roleEditEventFunc(ANALYTICS_EVENTS.SYS_EDIT_ROLE_SUCCESS, "Edit Role", eventParams);
          toast.success('Successfully updated');
          queryClient.invalidateQueries('roles');
          handleClick();
        }
      } catch (error) {
        const errMsg = error?.response?.data?.message || error?.message;
        roleEditEventFunc(ANALYTICS_EVENTS.SYS_EDIT_ROLE_ERROR, "Edit Role", { errMsg });
      }
    },

    validate: (values) => {
      let errors = {};
      if (!values.name) errors.name = 'Required';
      // if(!values.permissions) errors.permissions = 'Required';
      if (!values.permissions.length) errors.permissions = 'Required';
      return errors;
    },
  });

  return (
    <Model
      handleClick={handleClick}
      title={`${desable ? 'View' : 'Edit'} User Role & Permissions`}
      className="w-full max-w-2xl h-max"
      >
        <FormikProvider value={formik} className=" overflow-scroll">
          <Form className="px-5 text-gray-700 overflow-y-visible font-medium text-base grid lg:gap-x-14 gap-y-5 grid-flow-row grid-cols-1 lg:grid-cols-2 w-full h-full">
              <InputField
            type="text"
            label="User Role Name"
            name="name"
            desable={isDesable}
          />
          <br />
          <div className=" border-2 p-2 my-2 col-span-2 flex flex-col justify-center items-start gap-0 text-gray-600 font-normal">
            <label className="py-3">
              Select Permissions
              <Select
                styles={{
                  control: (styles) => ({
                    ...styles,
                    backgroundColor: "white",
                    minWidth: '500px',
                    // ? "white"
                    // : "#FF9193F",
                    // position: "relative",
                  }),
                  menuPortal: (styles) => ({
                    ...styles,
                    zIndex: 9999,
                    width: "100%",
                    fontWeight: "500",
                    fontSize: "14px",
                    lineHeight: "1.25rem" /* 20px */,
                  }),
                  menu: (styles) => {
                    return {
                      ...styles,
                      // positlion: "absolute",
                      opacity: 1,
                      // transform: "none",
                      // minWidth: "120px",
                      // transition: "opacity 251ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 167ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                      // top: "0",
                      // left: "0",
                      // zIndex: 10,
                      // overflow: "visible"
                      // transformOrigin: "60px 0px",
                    };
                  },
                  option: (
                    styles,
                    { data, isDisabled, isFocused, isSelected }
                  ) => {
                    const color = data.color;
                    return {
                      ...styles,
                      fontWeight: "400",
                      zIndex: 1000, // You can adjust the zIndex value as needed
                    };
                  },
                  input: (styles) => ({ ...styles }),
                  placeholder: (styles) => ({ ...styles, fontWeight: "400" }),
                  singleValue: (styles, { data }) => ({ ...styles }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={permissions?.map((permission) => {
                  return {
                    value: permission._id,
                    label: permission.name,
                  };
                })}
                value={
                  formik.values.permissions &&
                  formik.values.permissions?.map((permission) => {
                    return {
                      value: permission,
                      label: permissions.find((perm) => perm._id === permission)
                        ?.name,
                    };
                  })
                }
                onChange={(value) => {
                  formik.setFieldValue(
                    "permissions",
                    value.map((permission) => permission.value)
                  );
                }}
                name="permissions"
                isDisabled={isDesable}
                isMulti={true}
              />
              {formik.touched.permissions && formik.errors.permissions ? (
                <p className="text-red-500 font-normal">
                  *{formik.errors.permissions}
                </p>
              ) : null}
            </label>
          </div>
        </Form>
        {isDesable ? (
          <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
            <Button bgSecondary onClick={handleClick}>
              Cancel
            </Button>
            <Button type="button" bgPrimary onClick={() => setIsDesable(false)}>
              Edit
            </Button>
          </div>
        ) : (
          <div className="px-5 flex justify-end items-center gap-4 pb-8 flex-wrap sm:w-full">
            <Button bgSecondary onClick={handleClick}>
              Cancel
            </Button>
            <Button type="button" bgPrimary onClick={formik.handleSubmit}>
              Save Changes
            </Button>
          </div>
        )}
      </FormikProvider>
    </Model>
  );
};

export default EditPermissions;
